<div class="content-page">
    <app-nav-menu></app-nav-menu>

    <div class="content-page__header">
      @if(breakpointService.isMobile()) {
        <div class="content-page__label">
          About Us
        </div>
      }
        <app-header-banner
                [localAsset]="true"
                [showContent]="!breakpointService.isMobile()"
                bannerText="ABOUT_US.BANNER_TEXT"
                bannerDescription="ABOUT_US.BANNER_DESCRIPTION"
                [bannerImage]="breakpointService.isMobile() ? 'about_banner_mobile.jpg' : 'about_banner.jpg'"
        ></app-header-banner>
    </div>

    <div class="company-container__box">
        <div class="company-container__content">
            <h1 class="content-page__title">{{ 'ABOUT_US.TITLE' | translate }}</h1>
            @for (text of ('ABOUT_US.PARAGRAPHS' | translate); track $index) {
                <p class="content-page__paragraph">
                    {{ text }}
                </p>
            }

            <div class="statistics-box">
                <h2 class="statistics-box__title">RoutePerfect in numbers</h2>
                <ul class="statistics-box__list">
                    @for (statistic of tripsStatistic; track $index) {
                        <li class="statistics-box__item">
                            <div class="statistics-box__content">
                                <img class="statistics-box__icon" [src]="statistic.icon" [attr.alt]="statistic.text">

                                @if (breakpointService.isMobile()) {
                                  <div class="statistics-box__row">
                                    <p class="statistics-box__value">{{ statistic.value }}</p>
                                    <p class="statistics-box__text">{{ statistic.text }}</p>
                                  </div>
                                } @else {
                                  <p class="statistics-box__value">{{ statistic.value }}</p>
                                  <p class="statistics-box__text">{{ statistic.text }}</p>
                                }
                            </div>
                        </li>
                    }
                </ul>
            </div>
        </div>

      @if (!breakpointService.isMobile()) {
        <aside class="company-container__aside">
          <div class="start-chat">
            <h2>{{ 'ABOUT_US.START_CHAT.TITLE' | translate }}</h2>
            <p>{{ 'ABOUT_US.START_CHAT.DESCRIPTION' | translate }}</p>

            <button class="btn-default btn-primary start-chat__btn" (click)="openAiDialog()">
              {{ 'ACTIONS.START_CHATTING' | translate }}
            </button>
          </div>
          <app-popular-itineraries></app-popular-itineraries>
        </aside>
      }
    </div>
</div>

@if (breakpointService.isMobile()) {
  <div class="content-page content-page--mobile">
    <app-testimonials></app-testimonials>
    <app-start-planing-mobile></app-start-planing-mobile>
  </div>
}
